import { combineReducers } from "redux";
import * as classesReducer from "./classes";
import * as llistatReducer from "./llistat";

const rootReducer = combineReducers({
  introduccio: classesReducer.default,
  llistat: llistatReducer.default
});

export default rootReducer;

export const getClassesIntroduccio = state =>
  classesReducer.getClassesIntroduccio(state);

export const getClassesIntroduccioAsArray = state =>
  classesReducer.getClassesIntroduccioAsArray(state);

export const getLlistatClasses = state =>
  llistatReducer.getLlistatClasses(state);

export const getClassesAsArray = state => {
  llistatReducer.getClassesAsArray(state);
};
